
export enum EmptyTableType {
    // This enum maps to _emptyTable.scss for images
    users = 'users',
    vaults = 'vaults',
    applications = 'applications',
    emptySearch = 'emptySearch'
}



